import { computed } from "vue";
import store from "../../../store"
import { i18n } from "../../../../i18n";

export default function useOrderService() {
    const {
        t
    } = i18n.global

    const buttonText = computed(()=> getButtonText())

    function getButtonText(){
        const packeta = store.getters['packeta/getData']
        
        return packeta
                ? t('Change branch')
                : t('Choose branch')
    }

    function disableServiceButton(shipping) {
        const cartData = store.getters['cart/getCartData']

        return !cartData.shipping || cartData.shipping.id !== shipping.id;
    }

    function updatePacketa(point) {
        const data = {
            id: point.id,
            place: point.routingName,
            lat: point.gps.lat,
            lon: point.gps.lon
        }

        store.commit('packeta/SET_DATA', data)
    }

    function showSelectedPickupPoint(point) {
        if (point) {
            updatePacketa(point)
        } else {
            // clear packeta data
            store.commit('packeta/SET_DATA', null)
        }

        return false;
    }

    return {
        buttonText,
        disableServiceButton,
        showSelectedPickupPoint
    }
}
